import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { push } from 'connected-react-router'

// amplify
import { Auth, API } from 'aws-amplify'

// graphql
import { getCognitoAccountByCognitoID, getAuthAccount, getStaffInvitationByCode, getStaffInvitation, getStaffProfile, listVolunteerCausesByVolunteer, listVolunteerSkillsByVolunteer } from '../../graphql/queries'
import { createCognitoAccount, createAuthAccount, updateStaffInvitation, createStaffProfile, getStreamKey, createCommunicationsProfile, updateAuthAccount, updateCommunicationsProfile, updateStaffProfile } from '../../graphql/mutations'

import queryString from 'query-string'

import axios from 'axios'
import { toast } from 'react-toastify';
import { E164Number } from 'libphonenumber-js/core'

import { AuthAccount, CognitoAccount, CommunicationsProfile, StaffProfile, VolunteerCause, VolunteerSkill } from '../../../API'

import { setLoading } from './loading'
import { getCreateOrganizationInvitation } from './organization'

interface AuthAccountState {
    data: AuthAccount | null | undefined,
    cognitoData: CognitoAccount | null | undefined,
    authAccountId: string | null,
    verified: null | boolean,
    username: null | string,
    email: null | string,
    phoneNumber: null | string,
    password: null | string,
    sub: null | string,
    staffProfiles: StaffProfile[] | null | undefined,
    selectedStaffProfile: StaffProfile | null,
    staffInvitation: null | any
    communicationsProfile: CommunicationsProfile | null,
    firstName: string | null,
    lastName: string | null,
    causes: VolunteerCause[] | null,
    skills: VolunteerSkill[] | null,
}

interface Credentials {
    phoneNumber: E164Number,
    password: string
}

interface CognitoSignUpProps {
    phoneNumber: E164Number,
    email: string,
    password: string,
    firstName: string,
    lastName: string
}

interface IVerifyUser {
    code: string
}

enum AdminAccountType {
    root,
    staff,
    volunteer
}

const initialState: AuthAccountState = {
    data: null,
    cognitoData: null,
    authAccountId: null,
    verified: null,
    username: null,
    email: null,
    phoneNumber: null,
    password: null,
    sub: null,
    staffProfiles: null,
    selectedStaffProfile: null,
    staffInvitation: null,
    communicationsProfile: null,
    firstName: null,
    lastName: null,
    causes: null,
    skills: null
}

export const retrieveStaffInvitation: any = createAsyncThunk(
    'authAccount/retrieveStaffInvitation',
    async (code: string, { dispatch, getState }) => {
        try {
            const { data }: any = await API.graphql({
                query: getStaffInvitationByCode,
                variables: {
                    code: code
                }
            })

            console.log('staff invitation: ', data)

            if (data.getStaffInvitationByCode) {
                console.log(data.getStaffInvitationByCode.items[0])
                return data.getStaffInvitationByCode.items[0]
            }
        } catch (err) {
            console.error(err)
        }
    }
)

export const cognitoSignUp: any = createAsyncThunk(
    'authAccount/cognitoSignUp',
    async (props: CognitoSignUpProps, { dispatch }) => {
        try {

            dispatch(setLoading({
                loading: true,
                message: 'One moment...'
            }))

            try {
                const user = await Auth.signUp({
                    username: props.phoneNumber,
                    password: props.password,
                    attributes: {
                        email: props.email,
                        phone_number: props.phoneNumber
                    }
                })
                console.log('cognito sign up response', user)

                dispatch(setLoading({
                    loading: false,
                    message: 'Loading.'
                }))

                return {
                    username: user.userSub,
                    phoneNumber: props.phoneNumber,
                    email: props.email,
                    password: props.password,
                    firstName: props.firstName,
                    lastName: props.lastName
                }
            } catch (err: any) {
                const parsedErr = JSON.parse(JSON.stringify(err))
                console.log('error registering: ', parsedErr)
                dispatch(setLoading({
                    loading: false,
                    message: 'Loading.'
                }))

                if (parsedErr.code == 'UsernameExistsException') {
                    alert('An account already exists with that phone number. Try logging in.')
                    return parsedErr
                }
            }
        } catch (err) {
            dispatch(setLoading({
                loading: false,
                message: 'Loading.'
            }))
            console.error(err)
        }
    }
)

export const cognitoConfirmSignUp: any = createAsyncThunk(
    'authAccount/confirmSignUp',
    async (props: { phoneNumber: string, code: string, password: string }, { dispatch, getState }) => {
        try {

            dispatch(setLoading({
                loading: true,
                message: 'Creating your account. This may take a few moments.'
            }))

            const { authAccount }: any = getState()

            const verification = await Auth.confirmSignUp(props.phoneNumber, props.code)
            console.log('cognito verification response', verification)

            var communicationsProfile;

            if (verification == 'SUCCESS') {

                const user = await Auth.signIn(props.phoneNumber, authAccount.password)

                console.log('signed in user response: ', user)

                // create Auth Account

                const createAuthAccountResponse: any = await API.graphql({
                    query: createAuthAccount,
                    variables: {
                        input: {
                            primaryEmail: authAccount.email,
                            firstName: authAccount.firstName,
                            lastName: authAccount.lastName,
                            name: `${authAccount.firstName} ${authAccount.lastName}`
                        }
                    }
                })

                console.log('createAuthAccountResponse: ', createAuthAccountResponse)

                // create Cognito Account (this is not an account with Cognito but rather an account within DynamoDB
                // linking the actual Cognito account to the Auth Account)

                const createCognitoAccountResponse: any = await API.graphql({
                    query: createCognitoAccount,
                    variables: {
                        input: {
                            cognitoID: user.attributes.sub,
                            authAccountID: createAuthAccountResponse.data.createAuthAccount.id
                        }
                    }
                })

                console.log('createCognitoAccountResponse: ', createCognitoAccountResponse)

                // create CommunicationsProfile, then generate stream key, then update CommunicationsProfile with streamJwt

                const createCommunicationsProfileResponse: any = await API.graphql({
                    query: createCommunicationsProfile,
                    variables: {
                        input: {
                            authAccountID: createAuthAccountResponse.data.createAuthAccount.id
                        }
                    }
                })

                console.log('createCommunicationsProfileResponse: ', createCommunicationsProfileResponse)

                communicationsProfile = createCommunicationsProfileResponse.data.createCommunicationsProfile

                const updateAuthAccountResponse: any = await API.graphql({
                    query: updateAuthAccount,
                    variables: {
                        input: {
                            id: createAuthAccountResponse.data.createAuthAccount.id,
                            communicationsProfileID: communicationsProfile.id
                        }
                    }
                })

                console.log('updateAuthAccountResponse: ', updateAuthAccountResponse.data)

                const apiName = 'RESTfundraising';
                const path = '/stream';

                const response: any = await API.get(apiName, path, { "queryStringParameters": { "jwt": user.signInUserSession.idToken.jwtToken } });

                console.log('stream jwt response: ', response)

                const streamKey = response.token

                console.log(streamKey)

                if (streamKey) {

                    const updateCommunicationsProfileResponse = await API.graphql({
                        query: updateCommunicationsProfile,
                        variables: {
                            input: {
                                id: createCommunicationsProfileResponse.data.createCommunicationsProfile.id,
                                streamJwt: streamKey
                            }
                        }
                    })


                    console.log('communications profile updated: ', updateCommunicationsProfileResponse)
                }

                if (queryString.parse(window.location.search).ref == 'staff-invitation' && queryString.parse(window.location.search).code) {

                    if (authAccount.staffInvitation && authAccount.email == authAccount.staffInvitation.email) {

                        const getStaffProfileResponse: any = await API.graphql({
                            query: getStaffProfile,
                            variables: {
                                id: authAccount.staffInvitation.staffProfileID
                            }
                        })

                        const updateStaffProfileResponse: any = await API.graphql({
                            query: updateStaffProfile,
                            variables: {
                                input: {
                                    id: getStaffProfileResponse.data.getStaffProfile.id,
                                    authAccountID: createAuthAccountResponse.data.createAuthAccount.id
                                }
                            }
                        })

                        if (updateStaffProfileResponse) {
                            const updateStaffInvitationResponse: any = await API.graphql({
                                query: updateStaffInvitation,
                                variables: {
                                    input: {
                                        id: authAccount.staffInvitation.id,
                                        used: true,
                                        usedTimestamp: new Date()
                                    }
                                }
                            })
                            console.log('updateStaffInvitationResponse: ', updateStaffInvitationResponse.data)
                        }
                    } else {
                        const { data }: any = await API.graphql({
                            query: getStaffInvitationByCode,
                            variables: {
                                code: queryString.parse(window.location.search).code
                            }
                        })

                        console.log(queryString.parse(window.location.search).code)
                        console.log('retrieve staff invitation response: ', data)

                        console.log(authAccount, data.getStaffInvitationByCode)

                        if (authAccount.email == data.getStaffInvitationByCode.items[0].email) {
                            const getStaffProfileResponse: any = await API.graphql({
                                query: getStaffProfile,
                                variables: {
                                    id: data.getStaffInvitationByCode.items[0].staffProfileID
                                }
                            })

                            console.log('getStaffProfileResponse: ', getStaffProfileResponse.data)

                            const updateStaffProfileResponse: any = await API.graphql({
                                query: updateStaffProfile,
                                variables: {
                                    input: {
                                        id: getStaffProfileResponse.data.getStaffProfile.id,
                                        authAccountID: createAuthAccountResponse.data.createAuthAccount.id
                                    }
                                }
                            })

                            console.log('updateStaffProfileResponse: ', updateStaffProfileResponse.data)

                            if (updateStaffProfileResponse) {
                                const updateStaffInvitationResponse: any = await API.graphql({
                                    query: updateStaffInvitation,
                                    variables: {
                                        input: {
                                            id: data.getStaffInvitationByCode.items[0].id,
                                            used: true,
                                            usedTimestamp: new Date()
                                        }
                                    }
                                })
                            }

                            dispatch(push(`/admin/dashboard`))
                        } else {
                            alert('You must use the same email that the invitation was sent to to create your account.')
                        }
                    }
                } else if (queryString.parse(window.location.search).ref == 'org-create' && queryString.parse(window.location.search).code) {
                    await dispatch(getCreateOrganizationInvitation(queryString.parse(window.location.search).code))
                    dispatch(push(`/auth/register/organization${window.location.search}`))
                } else {
                    dispatch(push(`/admin/organization-registration`))
                }

                dispatch(setLoading({
                    loading: false,
                    message: 'Loading.'
                }))

                var cognitoData = null;

                if (user) {
                    cognitoData = {
                        email: user.attributes.email,
                        session: {
                            accessToken: user.signInUserSession.accessToken.jwtToken,
                            idToken: user.signInUserSession.idToken.jwtToken,
                            refreshToken: user.signInUserSession.refreshToken.jwtToken
                        }
                    }
                }

                const getAuthAccountResponse: any = await API.graphql({
                    query: getAuthAccount,
                    variables: {
                        id: createAuthAccountResponse.data.createAuthAccount.id
                    }
                })

                dispatch(verifyAccount())

                return {
                    authAccountId: getAuthAccountResponse.data.getAuthAccount.id,
                    cognitoData: cognitoData,
                    authAccount: getAuthAccountResponse.data.getAuthAccount,
                    communicationsProfile: communicationsProfile ? communicationsProfile : null
                }
            }

            dispatch(setLoading({
                loading: false,
                message: 'Loading.'
            }))

            return
        } catch (err) {
            dispatch(setLoading({
                loading: false,
                message: 'Loading.'
            }))
            console.error(err)
            toast.error(JSON.stringify(err), { containerId: 'main' })
        }
    }
)

export const cognitoSignIn: any = createAsyncThunk(
    'authAccount/cognitoSignIn',
    async (credentials: Credentials, { dispatch, getState }) => {
        try {

            dispatch(setLoading({
                loading: true,
                message: 'Logging you in...'
            }))

            const { authAccount }: any = getState()

            dispatch(setCredentials({ phoneNumber: credentials.phoneNumber, password: credentials.password }))

            const user = await Auth.signIn(credentials.phoneNumber, credentials.password)

            console.log('cognito sign in response', user)

            const { data }: any = await API.graphql({
                query: getCognitoAccountByCognitoID,
                variables: {
                    cognitoID: user.username
                }
            })

            var authAccountData = data.getCognitoAccountByCognitoID.items[0]

            var staffProfileData: any;

            if (user) {
                const queryParams: any = queryString.parse(window.location.search)
                console.log('current query string params: ', queryParams)

                if (queryParams && queryParams.ref == 'org-create' && queryParams.code) {
                    await dispatch(getCreateOrganizationInvitation(queryParams.code))
                    dispatch(push(`/auth/register/organization?code=${queryParams.code}`))
                } else if (queryParams && queryParams.ref == 'staff-invitation' && queryParams.code) {

                    console.log('staff profile creation initiated.')

                    const { data }: any = await API.graphql({
                        query: getStaffInvitationByCode,
                        variables: {
                            code: queryParams.code
                        }
                    })

                    console.log("get staff invitation response: ", data)

                    if (user.attributes.email == data.getStaffInvitationByCode.items[0].email) {
                        if (data.getStaffInvitationByCode.items[0].used == false) {
                            const getStaffProfileResponse: any = await API.graphql({
                                query: getStaffProfile,
                                variables: {
                                    id: data.getStaffInvitationByCode.items[0].staffProfileID
                                }
                            })

                            const updateStaffProfileResponse: any = await API.graphql({
                                query: updateStaffProfile,
                                variables: {
                                    input: {
                                        id: getStaffProfileResponse.data.getStaffProfile.id,
                                        authAccountID: authAccountData.authAccount.id
                                    }
                                }
                            })

                            if (updateStaffProfileResponse) {
                                staffProfileData = updateStaffProfileResponse.data.updateStaffProfile
                                const updateStaffInvitationResponse: any = await API.graphql({
                                    query: updateStaffInvitation,
                                    variables: {
                                        input: {
                                            id: data.getStaffInvitationByCode.items[0].id,
                                            used: true,
                                            usedTimestamp: new Date()
                                        }
                                    }
                                })

                                dispatch(push('/admin/dashboard'))
                            } else {
                                alert('Error creating staff profile. Please contact support.')
                                dispatch(push('/admin/dashboard'))
                            }
                        } else {
                            alert('This invitation code has already been used to create an account.')
                        }
                    } else {
                        alert('You must use the same email that the invitation was sent to to create your account.')
                    }
                } else {
                    const getAuthAccountResponse: any = await API.graphql({
                        query: getAuthAccount,
                        variables: {
                            id: data.getCognitoAccountByCognitoID.items[0].authAccountID
                        }
                    })

                    console.log('authAccountResponse: ', getAuthAccountResponse)

                    const staffProfiles = getAuthAccountResponse.data.getAuthAccount.staffProfile ? getAuthAccountResponse.data.getAuthAccount.staffProfile.items : []

                    if (staffProfiles.length >= 1) {
                        dispatch(push('/admin/dashboard'))
                    } else {
                        dispatch(push('/admin/select-organization'))
                    }

                    authAccountData = getAuthAccountResponse.data.getAuthAccount
                }
            }

            var cognitoData = null;

            if (user) {
                cognitoData = {
                    email: user.attributes.email,
                    session: {
                        accessToken: user.signInUserSession.accessToken.jwtToken,
                        idToken: user.signInUserSession.idToken.jwtToken,
                        refreshToken: user.signInUserSession.refreshToken.jwtToken
                    }
                }
            }

            dispatch(setLoading({
                loading: false,
                message: 'Loading.'
            }))

            return {
                cognitoData,
                authAccountData,
                staffProfileData
            }
        } catch (err: any) {
            dispatch(setLoading({
                loading: false,
                message: 'Loading.'
            }))
            console.log(JSON.stringify(err))
            console.log(err)
            if (err.name == 'UserNotFoundException') {
                toast.error('User not found with that phone number and password combination.', { containerId: 'main' })
                return null
            } else if (err.name == 'NotAuthorizedException') {
                toast.error("Phone number and password don't match", { containerId: 'main' })
                return null
            } else if (err.name == 'UserNotConfirmedException') {
                toast.warn('You still need to verify your account before you can log in.', { containerId: 'main' })
                return err
            }
        }
    }
)

export const reloadCognito: any = createAsyncThunk(
    'authAccount/reloadCognito',
    async (credentials: Credentials, { dispatch }) => {
        try {
            const user = await Auth.currentAuthenticatedUser()
            console.log('cognito current user response', user)

            const cognitoData = {
                email: user.attributes.email,
                session: {
                    accessToken: user.signInUserSession.accessToken.jwtToken,
                    idToken: user.signInUserSession.idToken.jwtToken,
                    refreshToken: user.signInUserSession.refreshToken.jwtToken
                }
            }
            return cognitoData
        } catch (err) {
            console.error(err)
        }
    }
)

export const reloadAuthAccount: any = createAsyncThunk(
    'authAccount/reloadAuthAccount',
    async (credentials: Credentials, { dispatch }) => {
        try {
            const user = await Auth.currentAuthenticatedUser({ bypassCache: true })
            console.log('cognito current user response', user)

            const { data }: any = await API.graphql({
                query: getCognitoAccountByCognitoID,
                variables: {
                    cognitoID: user.username
                }
            })

            console.log('cognitoAccountId: ', data.getCognitoAccountByCognitoID)

            const authAccountResponse: any = await API.graphql({
                query: getAuthAccount,
                variables: {
                    id: data.getCognitoAccountByCognitoID.items[0].authAccountID
                }
            })

            console.log('authAccountResponse: ', authAccountResponse.data.getAuthAccount)

            const authAccountData = authAccountResponse.data.getAuthAccount
            const staffProfiles = authAccountResponse.data.getAuthAccount.staffProfile ? authAccountResponse.data.getAuthAccount.staffProfile.items : null
            const communicationsProfile = authAccountData.communicationsProfile ? authAccountData.communicationsProfile : null

            console.log('reloaded auth account data: ', authAccountData)
            console.log('staff profiles: ', staffProfiles)
            console.log('reloaded communications profile: ', communicationsProfile)

            const cognitoData = {
                email: user.attributes.email,
                sub: user.attributes.sub,
                session: {
                    accessToken: user.signInUserSession.accessToken.jwtToken,
                    idToken: user.signInUserSession.idToken.jwtToken,
                    refreshToken: user.signInUserSession.refreshToken.jwtToken
                }
            }
            return {
                cognitoData,
                authAccountData,
                staffProfiles,
                communicationsProfile
            }
        } catch (err) {
            console.log(JSON.parse(JSON.stringify(err)))
        }
    }
)

export const cognitoSignOut: any = createAsyncThunk(
    'authAccount/cognitoSignOut',
    async (params, { dispatch }) => {
        try {
            dispatch(setLoading({
                loading: false,
                message: 'Signing you out...'
            }))
            await Auth.signOut()
            console.log('cognito sign out successful')
            dispatch(setLoading({
                loading: false,
                message: 'Loading.'
            }))
            dispatch(push('/'))
            return
        } catch (err) {
            dispatch(setLoading({
                loading: false,
                message: 'Loading.'
            }))
            console.error(err)
        }
    }
)

export const setSelectedStaffProfile: any = createAsyncThunk(
    'authAccount/setSelectedStaffProfile',
    async (staffProfile: StaffProfile, { dispatch, getState }) => {

        const { authAccount }: any = getState()

        const updateAuthAccountResponse = await API.graphql({
            query: updateAuthAccount,
            variables: {
                input: {
                    id: authAccount.data.id,
                    lastSelectedStaffProfileID: staffProfile.id
                }
            }
        })

        // using window.location.replace to do a refresh of the page to clear preview organization data and pull in new organization data
        window.location.replace('/admin/dashboard')
        // dispatch(push('/admin/dashboard'))

        return staffProfile
    }
)

export const updateProfilePictureURI: any = createAsyncThunk(
    'authAccount/updateProfilePictureURI',
    async (uri: string, { dispatch, getState }) => {

        const { authAccount }: any = getState()

        if (authAccount && authAccount.data) {
            const updateAuthAccountResponse: any = await API.graphql({
                query: updateAuthAccount,
                variables: {
                    input: {
                        id: authAccount.data.id,
                        profilePictureURI: uri
                    }
                }
            })

            if (updateAuthAccount && updateAuthAccountResponse.data && updateAuthAccountResponse.data.updateAuthAccount) {
                return updateAuthAccountResponse.data.updateAuthAccount
            } else {
                return null
            }


        }
    }
)

export const getVolunteerCausesAndSkills: any = createAsyncThunk(
    'authAccount/getVolunteerCausesAndSkills',
    async (props: any, { dispatch, getState }) => {

        const { authAccount }: any = getState()

        if (authAccount.data && authAccount.data.volunteerProfileID) {
            const listVolunteerCausesByVolunteerResponse: any = await API.graphql({
                query: listVolunteerCausesByVolunteer,
                variables: {
                    volunteerProfileID: authAccount.data.volunteerProfileID
                }
            })

            console.log(listVolunteerCausesByVolunteerResponse.data)

            const listVolunteerSkillsByVolunteerResponse: any = await API.graphql({
                query: listVolunteerSkillsByVolunteer,
                variables: {
                    volunteerProfileID: authAccount.data.volunteerProfileID
                }
            })

            console.log(listVolunteerSkillsByVolunteerResponse.data)

            if (listVolunteerCausesByVolunteerResponse.data && listVolunteerCausesByVolunteerResponse.data.listVolunteerCausesByVolunteer && listVolunteerCausesByVolunteerResponse.data.listVolunteerCausesByVolunteer.items && listVolunteerSkillsByVolunteerResponse.data && listVolunteerSkillsByVolunteerResponse.data.listVolunteerSkillsByVolunteer && listVolunteerSkillsByVolunteerResponse.data.listVolunteerSkillsByVolunteer.items) {
                return {
                    volunteerCauses: listVolunteerCausesByVolunteerResponse.data.listVolunteerCausesByVolunteer.items,
                    volunteerSkills: listVolunteerSkillsByVolunteerResponse.data.listVolunteerSkillsByVolunteer.items
                }
            } else {
                return {
                    volunteerCauses: [],
                    volunteerSkills: []
                }
            }
        } else {
            return {
                volunteerCauses: [],
                volunteerSkills: []
            }
        }
    }
)

export const updateNylasCalendarToken: any = createAsyncThunk(
    'authAccount/updateNylasCalendarToken',
    async (props: { token: string }, { dispatch, getState }) => {
        try {
            dispatch(setLoading({ loading: true, message: 'Updating Latent Calendar...' }))

            const { authAccount }: any = getState()

            if (authAccount && authAccount.selectedStaffProfile) {
                const updateStaffProfileResponse: any = await API.graphql({
                    query: updateStaffProfile,
                    variables: {
                        input: {
                            id: authAccount.selectedStaffProfile.id,
                            nylasCalendarToken: props.token
                        }
                    }
                })

                dispatch(setLoading({ loading: false, message: 'Updating Latent Calendar...' }))

                if (updateStaffProfileResponse && updateStaffProfileResponse.data && updateStaffProfileResponse.data.updateStaffProfile) {
                    return {
                        staffProfile: updateStaffProfileResponse.data.updateStaffProfile
                    }
                } else {
                    return null
                }
            }
        } catch (err) {
            console.error(err)
            dispatch(setLoading({ loading: false, message: 'Updating Latent Calendar...' }))
        }
    }
)

export const updateNylasPrimaryCalendar: any = createAsyncThunk(
    'authAccount/updateNylasPrimaryCalendar',
    async (props: { calendarID: string }, { dispatch, getState }) => {
        try {
            dispatch(setLoading({ loading: true, message: 'Updating Latent Calendar...' }))

            const { authAccount }: any = getState()

            if (authAccount && authAccount.selectedStaffProfile) {
                const updateStaffProfileResponse: any = await API.graphql({
                    query: updateStaffProfile,
                    variables: {
                        input: {
                            id: authAccount.selectedStaffProfile.id,
                            nylasPrimaryCalendarID: props.calendarID
                        }
                    }
                })

                dispatch(setLoading({ loading: false, message: 'Updating Latent Calendar...' }))

                if (updateStaffProfileResponse && updateStaffProfileResponse.data && updateStaffProfileResponse.data.updateStaffProfile) {
                    return {
                        staffProfile: updateStaffProfileResponse.data.updateStaffProfile
                    }
                } else {
                    return null
                }
            }
        } catch (err) {
            console.error(err)
            dispatch(setLoading({ loading: false, message: 'Updating Latent Calendar...' }))
        }
    }
)

export const updateNylasAccountID: any = createAsyncThunk(
    'authAccount/updateNylasAccountID',
    async (props: { id: string }, { dispatch, getState }) => {
        try {
            dispatch(setLoading({ loading: true, message: 'Updating Latent Calendar...' }))

            const { authAccount }: any = getState()

            if (authAccount && authAccount.selectedStaffProfile) {
                const updateStaffProfileResponse: any = await API.graphql({
                    query: updateStaffProfile,
                    variables: {
                        input: {
                            id: authAccount.selectedStaffProfile.id,
                            nylasAccountID: props.id
                        }
                    }
                })

                dispatch(setLoading({ loading: false, message: 'Updating Latent Calendar...' }))

                if (updateStaffProfileResponse && updateStaffProfileResponse.data && updateStaffProfileResponse.data.updateStaffProfile) {
                    return {
                        staffProfile: updateStaffProfileResponse.data.updateStaffProfile
                    }
                } else {
                    return null
                }
            }
        } catch (err) {
            console.error(err)
            dispatch(setLoading({ loading: false, message: 'Updating Latent Calendar...' }))
        }
    }
)

export const authAccountSlice = createSlice({
    name: 'authAccount',
    initialState,
    reducers: {
        clearLocalUserData: (state) => {
            state.data = null
        },
        verifyAccount: (state) => {
            state.verified = true
        },
        setCredentials: (state, { payload }) => {
            state.phoneNumber = payload.phoneNumber
            state.password = payload.password
        }
    },
    extraReducers: (builder) => {
        builder.addCase(cognitoSignUp.fulfilled, (state, { payload }) => {
            console.log('sign up thunk response: ', payload)
            if (payload.__type) {
                // throw alert
            } else {
                state.username = payload.username
                state.sub = payload.username
                state.phoneNumber = payload.phoneNumber
                state.email = payload.email
                state.password = payload.password
                state.verified = false
                state.firstName = payload.firstName
                state.lastName = payload.lastName
            }
        })
        builder.addCase(cognitoConfirmSignUp.fulfilled, (state, { payload }) => {
            if (payload && payload.authAccountId) {
                state.authAccountId = payload.authAccountId
            }
            if (payload && payload.communicationsProfile) {
                state.communicationsProfile = payload.communicationsProfile
            }
            if (payload && payload.authAccount) {
                state.data = payload.authAccount
            }
            if (payload && payload.cognitoData) {
                state.cognitoData = payload.cognitoData
            }
        })
        builder.addCase(cognitoSignIn.fulfilled, (state, { payload }) => {
            if (payload && payload.cognitoData) {
                state.cognitoData = payload.cognitoData
                state.email = payload.cognitoData.email
            }
            if (payload && payload.authAccountData) {
                state.data = payload.authAccountData
                state.authAccountId = payload.authAccountData.authAccountID
            }
            if (payload && payload.authAccountData && payload.authAccountData.staffProfile && payload.authAccountData.staffProfile.items) {
                state.staffProfiles = payload.authAccountData.staffProfile.items
            }
            if (payload && payload.staffProfileData) {
                state.selectedStaffProfile = payload.staffProfileData
            }
        })
        builder.addCase(updateProfilePictureURI.fulfilled, (state, { payload }) => {
            if (payload) {
                state.data = payload
            }
        })
        builder.addCase(reloadCognito.fulfilled, (state, { payload }) => {
            state.cognitoData = payload
            state.email = payload.email
        })
        builder.addCase(reloadAuthAccount.fulfilled, (state, { payload }) => {
            if (payload) {
                if (payload.cognitoData) state.cognitoData = payload.cognitoData
                if (payload.cognitoData) state.email = payload.cognitoData.email
                if (payload.authAccountData) state.data = payload.authAccountData
                if (payload.authAccountData) state.authAccountId = payload.authAccountData.id
                if (payload.staffProfiles) state.staffProfiles = payload.staffProfiles
                if (state.selectedStaffProfile == null && payload.staffProfiles && payload.staffProfiles.length == 1) {
                    console.log('selected staff profile: ', payload.staffProfiles[0])
                    state.selectedStaffProfile = payload.staffProfiles[0]
                } else if (state.selectedStaffProfile == null && payload.authAccountData.lastSelectedStaffProfile) {
                    state.selectedStaffProfile = payload.authAccountData.lastSelectedStaffProfile
                }
                if (payload.communicationsProfile) state.communicationsProfile = payload.communicationsProfile
            }
        })
        builder.addCase(cognitoSignOut.fulfilled, (state, { payload }) => {
            state.cognitoData = null
            state.authAccountId = null
            state.email = null
            state.staffProfiles = null
            state.selectedStaffProfile = null
            state.password = null
            state.data = null
            state.sub = null
        })
        builder.addCase(retrieveStaffInvitation.fulfilled, (state, { payload }) => {
            state.staffInvitation = payload
        })
        builder.addCase(setSelectedStaffProfile.fulfilled, (state, { payload }) => {
            state.selectedStaffProfile = payload
        })
        builder.addCase(getVolunteerCausesAndSkills.fulfilled, (state, { payload }) => {
            state.causes = payload.volunteerCauses
            state.skills = payload.volunteerSkills
        })
        builder.addCase(updateNylasCalendarToken.fulfilled, (state, { payload }) => {
            if (payload.staffProfile) {
                state.selectedStaffProfile = payload.staffProfile
            }
        })
        builder.addCase(updateNylasPrimaryCalendar.fulfilled, (state, { payload }) => {
            if (payload.staffProfile) {
                state.selectedStaffProfile = payload.staffProfile
            }
        })
        builder.addCase(updateNylasAccountID.fulfilled, (state, { payload }) => {
            if (payload.staffProfile) {
                state.selectedStaffProfile = payload.staffProfile
            }
        })
    }
})

export const { clearLocalUserData, verifyAccount, setCredentials } = authAccountSlice.actions
export default authAccountSlice.reducer